import { Stack } from '@mui/material';

import Button from '../../../../../../components/Button';
import Typography from '../../../../../../components/Typography';
import PauseIcon from '../../../../../../icons/PauseIcon';
import PlayIcon from '../../../../../../icons/PlayIcon';
import { Digit } from './styles';
import useStopWatch from './vm';

const StopWatch = () => {
  const {
    isTimerRunning,
    minutes1,
    minutes2,
    seconds1,
    seconds2,
    canStartTimer,
    handleStartTimer,
    handlePauseTimer,
  } = useStopWatch();
  return (
    <Stack alignItems="center" gap={4}>
      <Stack direction="row" alignItems="center" gap={2} p={2} color="common.black">
        <Stack direction="row" alignItems="center" fontSize={(theme) => theme.typography.pxToRem(64)}>
          <Digit>{minutes1}</Digit>
          <Digit>{minutes2}</Digit>
        </Stack>
        <Typography variant="paragraphRegular" fontSize={(theme) => theme.typography.pxToRem(48)}>
          :
        </Typography>
        <Stack direction="row" alignItems="center" fontSize={(theme) => theme.typography.pxToRem(64)}>
          <Digit>{seconds1}</Digit>
          <Digit>{seconds2}</Digit>
        </Stack>
      </Stack>
      {isTimerRunning ? (
        <Button type="button" iconOnly variant="text" size="small" onClick={handlePauseTimer}>
          <PauseIcon size={32} color="primary" />
        </Button>
      ) : (
        <Button
          type="button"
          iconOnly
          variant="text"
          size="small"
          disabled={!canStartTimer}
          onClick={handleStartTimer}
        >
          <PlayIcon size={32} color="success" />
        </Button>
      )}
    </Stack>
  );
};

export default StopWatch;
